import React from 'react';
import cx from 'classnames';
const CONTACT_US = 'http://www.hartfordcity.net/';
const YOUTUBE = '';
const FACEBOOK = '';
function Footer({ className }) {
    return (<footer className={cx('footer', className)} data-testid="footer">
      <div className="footer-wrapper">
        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} Comcate, Inc.
        </p>
        <nav className="footer-nav">
          {/* Contact Us and social media links hidden per design */}
        </nav>
      </div>
    </footer>);
}
export default Footer;
